import { closestAll } from '../aha-menu/helpers';

// When the user clicks anywhere on the page, we need to determine if we should/should not close
// any `<aha-menu-content>` elements which are open, as well as any associated sub-menus.
window.addEventListener(
  'click',
  e => {
    const paths = e.composedPath();

    // look for the first aha-menu or aha-menu-content in the path
    // if it's an aha-menu, and it's open, then do nothing, as the click handler in aha-menu will already take care of it.
    // if we're in an aha-menu-content, then we need to proceed as there may be other menus to close
    const el = paths.find(node => ['AHA-MENU', 'AHA-MENU-CONTENT'].includes(node.tagName));
    if (el && el.tagName === 'AHA-MENU' && el.open) return;

    // This is a click event which is generated (perhaps from a selectro v1 handler), not a
    // natural browser event.

    if (paths[0] && paths[0].tagName === 'HTML') return;

    // If a mouseup happens inside of a .selectro-modal (from selectro v1), then do nothing.
    if (
      paths.some(
        node =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.classList.contains('selectro-popup') ||
            node.tagName === 'aha-menu-content' ||
            node.classList.contains('datepicker-dropdown') ||
            node.classList.contains('selectro-overlay')),
      )
    )
      return;

    // If we are clicking inside a colorpicker, do nothing, as the color picker may be inside the menu.
    if (
      paths.some(node => {
        return node.nodeType === Node.ELEMENT_NODE && node.matches('.small-colorpicker');
      })
    )
      return;

    // If we clicked inside an aha-menu-content, then walk each open aha-menu-content
    // and see if the menu-content we clicked into has a parent/grand-parent menu-content.
    // If it does, then leave that parent/grand-parent menu-content open.
    const poppedMenuContents = new Set(document.querySelectorAll('aha-menu-content[open]'));

    const nestedMenuContents = new Set(closestAll(e.target, 'aha-menu-content'));

    poppedMenuContents.forEach(poppedMenuContent => {
      if (!nestedMenuContents.has(poppedMenuContent)) {
        poppedMenuContent.hide();
        const parentMenu = poppedMenuContent.parentElement;
        setTimeout(() => {
          if (parentMenu && parentMenu.tagName === 'AHA-MENU') parentMenu.hide();
        }, 100);
      }
    });
  },
  { capture: true },
);

// Close menu when right-clicking outside the menu.
window.addEventListener('mousedown', e => {
  if (e.button === 2) {
    // If we are clicking on an already open menu, do nothing, as the click handler in aha-menu will already take care of it.
    const targetIsMenu = e.target.closest('aha-menu');
    if (targetIsMenu && targetIsMenu.open) return;

    // If we clicked inside an aha-menu-content, then walk each open aha-menu-content
    // and see if the menu-content we clicked into has a parent/grand-parent menu-content.
    // If it does, then leave that parent/grand-parent menu-content open.
    const poppedMenuContents = new Set(document.querySelectorAll('aha-menu-content[open]'));

    const nestedMenuContents = new Set(closestAll(e.target, 'aha-menu-content'));

    poppedMenuContents.forEach(poppedMenuContent => {
      if (!nestedMenuContents.has(poppedMenuContent)) {
        poppedMenuContent.hide();
        const parentMenu = poppedMenuContent.parentElement;
        if (parentMenu && parentMenu.tagName === 'AHA-MENU') parentMenu.hide();
      }
    });
  }
});
